<template>
  <div>
    <main>
      <section class="relative w-full h-full min-h-screen">
        <div class="absolute top-0 w-full h-full"></div>
        <router-view />
      </section>
    </main>
  </div>
</template>
<script>


export default {
  data() {
    return {
    };
  },
  components: {
  },
  mounted() {
    let iframScript = document.createElement('script')
    iframScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.2/iframeResizer.contentWindow.js')
    document.head.appendChild(iframScript)
  },
};
</script>
